import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { Campaign, CampaignPolicyTabs, CampaignSection } from '../../_models';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CampaignService, LoaderService, SideNavService } from '../../_services';
import { FormBuilder } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Widgetv2TableComponent } from '../../widget-v2/widget-v2-table.component';
import { expandCollapse } from '../../_shared/animations/app-animations';
import { CrudGetComponent } from '../../_directives/crud-get.component';

@Component({
  templateUrl: './campaign-policy.component.html',
  styleUrls: ['../campaign-section.scss', './campaign-policy.component.scss'],
  animations: [expandCollapse],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignPolicyComponent extends CrudGetComponent {
  public section = CampaignSection.PolicyAndTerms;
  @ViewChild(Widgetv2TableComponent, { static: false }) widgetsTable: Widgetv2TableComponent;
  public PolicyTabs = CampaignPolicyTabs;
  campaign: Campaign;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected sideNav: SideNavService,
    protected modalService: NgxSmartModalService,
    protected loaderService: LoaderService
  ) {
    super(router, location, route, campaignService, alertService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.campaign = this.campaignService.getCurrentCampaign();
    this.id = this.campaign.id;
    this.sideNav.setSideNavExpanded(false);
  }

  addNewWidget() {
    if (this.widgetsTable) {
      this.widgetsTable.create();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.sideNav.setSideNavExpanded(true);
  }
}
